/**
 * A route test's texts (user, 19/10/2026: "the route test could use the text
 * ranking — the best texts for the test drops"). A route test compares
 * gateways and senders, so every test drop of the day sends the SAME texts:
 * the best of the master's text ranking by default (proven only, 5), or
 * fresh AI texts — one set for all test drops either way. The choice is the
 * route test's own, kept with its other route test settings (the gateway
 * ranking JSON), whatever master it follows; a short pool is topped up with
 * fresh AI texts (`effectiveMix`).
 * For Media Devoted | Created By Ciro Autiero
 */
import { clampMix, type DropGenTextMix } from "../text-policy";

/** By default: the 5 best texts of the ranking, nothing else. */
export const DEFAULT_ROUTE_TEST_TEXTS: DropGenTextMix = { proven: 5, ai: 0 };

/** The route test's mix from its stored choice (absent or malformed = the default). */
export function routeTestTexts(stored: unknown): DropGenTextMix {
  if (typeof stored !== "object" || stored === null) return DEFAULT_ROUTE_TEST_TEXTS;
  const r = stored as { proven?: unknown; ai?: unknown };
  const proven = typeof r.proven === "number" ? r.proven : 0;
  const ai = typeof r.ai === "number" ? r.ai : 0;
  const mix = clampMix({ proven, ai });
  return mix.proven + mix.ai > 0 ? mix : DEFAULT_ROUTE_TEST_TEXTS;
}

/** "the 5 best ranked texts" · "5 fresh AI texts" · "3 ranked + 2 AI texts". */
export function routeTestTextsWords(m: DropGenTextMix): string {
  if (m.proven > 0 && m.ai > 0) return `${m.proven} ranked + ${m.ai} AI texts`;
  if (m.proven > 0) return m.proven === 1 ? "the best ranked text" : `the ${m.proven} best ranked texts`;
  return `${m.ai} fresh AI text${m.ai === 1 ? "" : "s"}`;
}
